import BaseError from './BaseError';

class UserError extends BaseError {}

export default UserError;
